'use client'

import { useCallback, useState } from 'react'
import { AppError } from '@/lib/errors/appError'

export function reportError(error: unknown, context?: Record<string, unknown>) {
  const appError = AppError.fromUnknown(error)
  if (process.env.NODE_ENV !== 'production') {
    console.error(
      '[reportError]',
      appError.kind,
      appError.message,
      context,
      appError.cause ?? error,
    )
  }
  // Wire to a real telemetry sink (Sentry, etc.) here once one exists.
}

/**
 * Lets an event handler or async callback escalate to the nearest error
 * boundary — React only catches throws during render, so this stashes the
 * error in state and rethrows on the next render.
 */
export function useErrorHandler() {
  const [error, setError] = useState<unknown>(null)
  if (error) throw error
  return useCallback((err: unknown) => setError(err), [])
}
